import { put, takeLatest } from 'redux-saga/effects';
import { PersonalTaskAPI } from 'api/personal-tasks';
import { logger } from 'services';
import { deleteStart, deleteSuccess, deleteFailed } from '..';
import { deletePersonalTaskSagaAction } from '../actions';
function* deletePersonalTaskSaga(action) {
    const { payload } = action;
    try {
        yield put(deleteStart(payload));
        yield PersonalTaskAPI.deletePersonalTask(payload.personalTaskId);
        yield put(deleteSuccess(payload));
    } catch (error) {
        logger.error('deletePersonalTask failed', {
            error
        });
        yield put(deleteFailed());
    }
}
export function* watchDeletePersonalTasksSaga() {
    yield takeLatest(deletePersonalTaskSagaAction.type, deletePersonalTaskSaga);
}
